<template>
  <div class="about-us" id="aboutUs">
    <header class="page-header" data-aos="fade-up">
      <div class="video-container">
        <video class="header-video" src="static/img/about-us/falcon.mp4" autoplay loop></video>
      </div>
      <div class="container">
        <div v-html="$t('about.hedingTopText')" class="heading-text" data-aos="fade-up">
        </div>
        <p data-aos="fade-up" v-html="$t('about.hedingSubText')"></p>
        <span class="line" data-aos="fade-up"></span>
        <p data-aos="fade-up" v-html="$t('about.headingText')"></p>
        <div
            class="btn-hover"
            @click="openVideoModal('presentation')"
          >
            <div class="btn orange" data-aos="fade-up" data-aos-delay="250">{{$t('component.watchPromoVideo')}}<span/></div>
        </div>
      </div>
      <a @click="smoothScroll" href="#top" :data-scroll-offset="scrollOffset" class="more-about-us white" data-aos="fade-up"><span>{{ $t('component.moreAboutUs') }}</span></a>
    </header>
    <div id="top" class="heading clearfix">
      <div class="description">
        <div v-html="$t('about.headSectionTopText')" class="text" data-aos="fade-up"></div>
        <p data-aos="fade-up" v-html="$t('about.headSectionText')"></p>
      </div>
      <div class="image">
        <figure class="hexagon-image" style="background-image: url('static/img/about-us/why-us.jpg')" data-aos="fade-up" data-aos-delay="100">
          <div class="hexTop"></div>
          <div class="hexBottom"></div>
        </figure>
      </div>
    </div>
    <div class="divider" data-aos="fade-up">
      <div class="line-horizontal-start"></div>
      <div class="line-diagonal"></div>
      <div class="line-horizontal-end"></div>
    </div>
     <div class="certs" data-aos="fade-up">
      <div class="heading">
        <div v-html="$t('about.ourCertsTitle')" class="heading-text"></div>
      </div>
      <certs/>
    </div>
    <div class="our-team orange-bg">
      <div class="top-text">
        <div v-html="$t('about.ourTeamTitle')" class="text" data-aos="fade-up"></div>
        <div class="description" data-aos="fade-up" data-aos-delay="100">
          <p v-html="$t('about.ourTeamText')"></p>
        </div>
      </div>
          <!-- <hr /> -->
          <div class="grid">
            <div class="team-box" v-for="member in team" :key="member.img">
              <img v-bind:src="'static/img/team/'+member.img+'?2'" v-bind:alt="member.name" data-aos="fade-up" data-aos-delay="100">
              <div class="text" data-aos="fade-up" data-aos-delay="200">
                <div class="name">{{ member.name }}</div>
                <div class="role">{{ member.role }}</div>
              </div>
            </div>
          </div>
    </div>
    <clients></clients>
    <media-box></media-box>
    <footer-more-information :modalpage="''"/>
    <footer-main/>
  </div>
</template>

<script>
import FooterMain from '../components/FooterMain';
import FooterMoreInformation from '../components/FooterMoreInformation';
import MediaBox from '../components/MediaBox';
import Clients from '../components/Clients';
import smoothScroll from '../helpers/SmoothScroll';
import Certs from '../components/Certs.vue';

export default {
  name: 'about-us',
  data() {
    return {
      popupActivo: false,
      popupActivo2: false,
      team: this.$root.$t("team")
    }
  },
  watch:{
    lang(){
      this.team = this.$root.$t("team")
    }
  },
  props: ['isHome'],
  methods: {
     openVideoModal(type) {
       this.$store.commit('SET_MODAL_STATIC_VIDEO_TYPE', type);
       this.$modal.show('video-static');
      }
  },
  components: {
    FooterMain,
    Clients,
    FooterMoreInformation,
    MediaBox,
    Certs
  },
  computed: {
    lang: () => {
      return store.state.lang;
    },
    scrollOffset: () => {
      return window.innerWidth > 980 ? 130 : 90;
    },
    smoothScroll: () => smoothScroll
  }
}
</script>

<style scoped>
@import "https://use.fontawesome.com/releases/v5.7.1/css/all.css";

</style>



// WEBPACK FOOTER //
// AboutUs.vue?1a0447be